import { combineEpics as _combineEpics } from "redux-observable";

import { CombineEpics } from "./interface";

export function combineEpics<Epics extends Array<(action: any, state: any, deps: any) => any>>(
  ...epics: Epics
): CombineEpics<Epics> {
  return _combineEpics(...epics) as CombineEpics<Epics>;
}
